import React from 'react';

import { WorkoutPlanType } from 'types/workouts';

import Skeleton from '../../../components/Skeleton';
import { PlanContainer } from '../components';
import { EmptyPlan } from '../components';

import { useWorkoutPlanCopy } from './useWorkoutPlanCopy';

type PlanState = 'loading' | 'empty' | 'filled';

interface UseWorkoutPlanComponentMapProps {
    plan: (WorkoutPlanType & { done: boolean })[];
    isLoading: boolean;
    onItemClick: (item: Pick<WorkoutPlanType, 'hash' | 'workout_id'>) => void;
}

const getPlanState = (isLoading: boolean, hasPlan: boolean): PlanState => {
    if (isLoading) {
        return 'loading';
    }
    if (hasPlan) {
        return 'filled';
    }

    return 'empty';
};

export const useWorkoutPlanComponentMap = ({ plan, isLoading, onItemClick }: UseWorkoutPlanComponentMapProps) => {
    const { emptyState, header } = useWorkoutPlanCopy();

    const state = getPlanState(isLoading, plan.length > 0);

    const contentMap: Record<PlanState, React.ReactElement> = {
        loading: <Skeleton height={180} mb={16} marginTop={24} />,
        empty: <EmptyPlan copy={emptyState} />,
        filled: <PlanContainer plan={plan} onClick={onItemClick} copy={{ header }} />,
    };

    return contentMap[state];
};
